
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.325 7.083c-1.892-.491-2.5-1-2.5-1.791 0-.909.842-1.542 2.25-1.542 1.483 0 2.033.708 2.083 1.75H9c-.058-1.433-.933-2.75-2.675-3.175V.5h-2.5v1.8C2.208 2.65.908 3.7.908 5.308c0 1.925 1.592 2.884 3.917 3.442 2.083.5 2.5 1.233 2.5 2.008 0 .575-.408 1.492-2.25 1.492-1.717 0-2.392-.767-2.483-1.75H.758c.1 1.825 1.467 2.85 3.067 3.192V15.5h2.5v-1.792c1.625-.308 2.917-1.25 2.917-2.958 0-2.367-2.025-3.175-3.917-3.667z","fill":"#24201F"}})])
          )
        }
      }
    